// App.js
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider, useQuery } from "@tanstack/react-query";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from './components/ScrollToTop';
import Home from "./pages/Home";

// Lazy-loaded routes to enable code splitting
import React, { Suspense, lazy } from "react";

const SearchResultsPage = lazy(() => import("./pages/SearchResultsPage"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogDetail = lazy(() => import("./pages/BlogDetail"));
const FilteredSportsPage = lazy(() => import("./pages/FilteredSportsPage"));
const ProviderDetailsPage = lazy(() => import("./pages/ProviderDetailsPage"));
const AboutUsPage = lazy(() => import("./pages/AboutUsPage"));

// Replace this line in your App.js:
// const queryClient = new QueryClient();

// With this configuration:

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Prevent refetching on window focus
      refetchOnWindowFocus: false,
      // Prevent refetching on reconnect
      refetchOnReconnect: false,
      // Prevent refetching on mount if data exists
      refetchOnMount: false,
      // Keep data fresh for longer
      staleTime: 30 * 60 * 1000, // 5 minutes
      // Keep data in cache longer
      gcTime: 60 * 60 * 1000, // 10 minutes
      // Prevent retries that might cause loading states
      retry: false,
      // Prevent refetch on window focus
      refetchOnWindowFocus: false,
    },
  },
});

const fetchSportsAndCourses = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/search-filter/sports/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify({
      include_courses_info: true,
      include_location_info: true,
      limit: "100",
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch sports and courses.");
  }

  return response.json();
};

export const useSportsData = () => {
  return useQuery({
    queryKey: ["sports"],
    queryFn: fetchSportsAndCourses,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
  });
};

const App = () => {
  // sports data will be fetched lazily within components using useSportsData


  
  

  return (
    <Router>
      <ScrollToTop />
      <Navbar loginButtonText="Login" />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search-results" element={<SearchResultsPage />} />
          <Route path="/land-adventure" element={<FilteredSportsPage />} />
          <Route path="/air-adventure" element={<FilteredSportsPage />} />
          <Route path="/water-adventure" element={<FilteredSportsPage />} />
          <Route path="/blogs-page" element={<BlogPage />} />
          <Route path="/blog/:blogId" element={<BlogDetail />} />
          <Route path="/provider" element={<ProviderDetailsPage />} />
          <Route path="/about" element={<AboutUsPage />} />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  );
};

const AppWrapper = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  );
};

export default AppWrapper;